// i18n.js

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          city: "City",
          email: "Email",
          "go-back": "Go back?",
          "go-site": "Go to Site",
          login: "Log in",
          "login-intro":
            "Log in to Retta Insight with your email and password.",
          "no-results": "No results found!",
          "no-username": "No access yet?",
          password: "Password",
          "please-contact":
            "Please contact your Key Account Manager for access rights.",
          "please-select":
            "Please select the company or property whose Retta Insights - site you want to open",
          portfolio: "Portfolio",
          "search-list": "Search from the list...",
          "select-portfolio": "Select portfolio site",
          "select-property": "Select property site",
          "sort-by": "Sort by",
          "you-appear-no-access":
            "You do not have access to Retta Insight service.",
        },
      },
      fi: {
        translation: {
          city: "Kaupunki",
          email: "Sähköposti",
          "go-back": "Mennäänkö takaisin?",
          "go-site": "Siirry sivustolle",
          login: "Kirjaudu sisään",
          "login-intro":
            "Kirjaudu sisään Retta Insightiin sähköpostiosoitteellasi ja salasanallasi.",
          "no-results": "Tuloksia ei löytynyt!",
          "no-username": "Ei vielä oikeuksia?",
          password: "Salasana",
          "please-contact": "Ota yhteyttä pääasiakaspäällikköösi.",
          "please-select":
            "Valitse yritys tai kiinteistö, jonka Retta Insights -sivuston haluat avata.",
          portfolio: "Portfolio",
          "search-list": "Etsi listalta...",
          "select-portfolio": "Valitse portfolion sivusto",
          "select-property": "Valitse kiinteistön sivusto",
          "sort-by": "Lajittele",
          "you-appear-no-access":
            "Vaikuttaa siltä, että sinulla ei ole oikeuksia Retta Insight palveluun.",
        },
      },
      sv: {
        translation: {
          city: "Stad",
          email: "E-post",
          login: "Logga in",
          "go-site": "Gå till webbplatsen",
          "go-back": "Gå tillbaka?",

          "login-intro":
            "Logga in på Retta Insight med din e-postadress och lösenord.",
          "no-results": "Inga resultat hittades!",
          "no-username": "Ingen tillgång än?",
          password: "Lösenord",
          "please-contact":
            "Vänligen kontakta din kundansvarige för att få åtkomsträttigheter.",
          "please-select":
            "Vänligen välj det företag eller den egendom vars Retta Insights - webbplats du vill öppna.",
          portfolio: "Portfölj",
          "search-list": "Sök från listan...",
          "select-portfolio": "Välj portföljplats",
          "select-property": "Välj fastighetsplats",
          "sort-by": "Sortera efter",
          "you-appear-no-access":
            "Det verkar som att du inte har tillgång till Retta Insight-tjänsten.",
        },
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
